import {AppContext} from "../context/AppProvider";
import {useContext} from "react";

function useCan(permission) {
	const {permissions} = useContext(AppContext);
	return typeof permissions !== 'undefined' && typeof permissions[permission] !== 'undefined' && permissions[permission] === true;
}

export default useCan;